
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-220w-solar-panel",
      function () {
        return require("private-next-pages/new-220w-solar-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-220w-solar-panel"])
      });
    }
  